import { useTypedSelector } from '@/store/store';
import { selectDealer } from '@/store/reducers/single-dealer';
import { selectSeoTemplate } from '@/store/reducers/seo-template';
import { SEOTemplate } from '@/typings/model';
import { getSingleDealerSeo } from '@/modules/Dealers/pages/Dealer/helpers';

export const useSingleDealerSeo = () => {
  const dealer = useTypedSelector(selectDealer);
  const seoTemplate = useTypedSelector(selectSeoTemplate);

  const brand =
    dealer && dealer.brands && dealer.brands.length > 0
      ? dealer.brands.map(({ name }) => name ?? '').join(', ')
      : '';
  const singleDealerSeo = getSingleDealerSeo(
    dealer?.name ?? '',
    brand,
    seoTemplate
  );
  const convertedSeoTemplate: SEOTemplate = {
    h1: singleDealerSeo?.h1 ?? '',
    keywords: singleDealerSeo?.keywords ?? '',
    title: dealer?.pageTitle ?? singleDealerSeo?.title ?? '',
    description: dealer?.pageDescription ?? singleDealerSeo?.description ?? '',
    openGraphImage:
      dealer?.pageOpenGraphImage ?? singleDealerSeo?.openGraphImage ?? '',
  };

  return convertedSeoTemplate;
};
